module.exports = __webpack_public_path__ + "static/img/xcximg.4d78de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/xcximg.jpg
// module id = 80H7
// module chunks = 28